import { render } from "./QuarterForm.vue?vue&type=template&id=60da2f63&scoped=true"
import script from "./QuarterForm.vue?vue&type=script&lang=js"
export * from "./QuarterForm.vue?vue&type=script&lang=js"

import "./QuarterForm.vue?vue&type=style&index=0&id=60da2f63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60da2f63"]])

export default __exports__